'use client';

import type { FC, HTMLAttributes } from 'react';
import { TextDeco } from '@paypoteam/page-components';

const DecoContent: FC<HTMLAttributes<HTMLParagraphElement>> = ({
    children,
}) => (
    <TextDeco
        className="font-secondary"
        size="s"
    >
        {children}
    </TextDeco>
);

export default DecoContent;
